import frontImageUrl from './assets/5f1273168518610584c09098fdd69d0fbc549965.png'
import type { CenteringSide } from './share/lib/types'

const frontCentering: CenteringSide = {
  top: 0.507,
  bottom: 0.493,
  left: 0.515,
  right: 0.485,
}

const backCentering: CenteringSide = {
  top: 0.508,
  bottom: 0.492,
  left: 0.512,
  right: 0.488,
}

export const homepageDemoSlab = {
  frontImageUrl,
  backImageUrl: frontImageUrl,
  cardName: 'Moltres Ex',
  cardNumber: '125',
  officialCount: '094',
  setName: 'Phantasmal Flames',
  language: 'English',
  grade: '10',
  provider: 'PSA' as const,
  confidencePercent: 82,
  paletteColor: '#f52232',
  centering: {
    front: frontCentering,
    back: backCentering,
  },
}
